import React, { useRef, useState } from 'react'

import LeftNavActiveBar from '../../LeftNavActiveBar/LeftNavActiveBar'
import GradientContainer, {
  type GradientContainerProps,
} from '../GradientContainer/GradientContainer'
import { LeftNav, type LeftNavProps } from '../../LeftNav'
import LeftNavLink, {
  type LeftNavLinkProps,
} from '../../LeftNavLink/LeftNavLink'
import styles from '../_left-nav-common.module.scss'

type LeftNavLinkContainerProps = Omit<GradientContainerProps, 'children'> & {
  leftNavLinks: LeftNavProps['leftNavLinks']
  breadcrumbs: LeftNavProps['breadcrumbs']
  isExpanded: LeftNavLinkProps['isExpanded']
  isUseable: LeftNavLinkProps['isUseable']
  environment?: LeftNavProps['environment']
  routerComponent: LeftNavProps['routerComponent']
  routerProp: LeftNavProps['routerProp']
  close: () => void
}

const LeftNavLinkContainer = ({
  containerHeight,
  containerScrollHeight,
  leftNavLinks,
  breadcrumbs,
  isExpanded,
  isUseable,
  environment,
  routerComponent,
  routerProp,
  close,
}: LeftNavLinkContainerProps): React.JSX.Element => {
  const [activeBarPosition, setActiveBarPosition] = useState(0),
    topLinks = leftNavLinks
      ? (leftNavLinks.filter((link) => !link.footerLink) ?? [])
      : [],
    bottomLinks = leftNavLinks
      ? (leftNavLinks.filter((link) => link.footerLink) ?? [])
      : [],
    elRef = useRef<HTMLDivElement>(null),
    topOfLinkContainer = elRef.current?.getBoundingClientRect().top ?? 0

  return (
    <>
      <LeftNavActiveBar
        activeBarTopPos={activeBarPosition}
        environment={environment}
      />
      <GradientContainer
        containerHeight={containerHeight}
        containerScrollHeight={containerScrollHeight}
      >
        <div className={styles.linkContainer} ref={elRef}>
          <div>
            {topLinks.map((sidebarLink, index) => (
              <React.Fragment key={sidebarLink.name}>
                <LeftNavLink
                  content={sidebarLink}
                  firstBreadcrumb={breadcrumbs[0]}
                  index={index}
                  close={close}
                  setActiveBarPosition={setActiveBarPosition}
                  isExpanded={isExpanded}
                  isUseable={isUseable}
                  topOfLinkContainer={topOfLinkContainer}
                  routerComponent={routerComponent}
                  routerProp={routerProp}
                />
              </React.Fragment>
            ))}
          </div>
          <div>
            {bottomLinks.length > 0 ? <LeftNav.Divider /> : null}
            {bottomLinks.map((sidebarLink, index) => (
              <React.Fragment key={sidebarLink.name}>
                <LeftNavLink
                  content={sidebarLink}
                  firstBreadcrumb={breadcrumbs[0]}
                  index={index + topLinks.length}
                  close={close}
                  setActiveBarPosition={setActiveBarPosition}
                  isExpanded={isExpanded}
                  isUseable={isUseable}
                  topOfLinkContainer={topOfLinkContainer}
                  routerComponent={routerComponent}
                  routerProp={routerProp}
                />
              </React.Fragment>
            ))}
          </div>
        </div>
      </GradientContainer>
    </>
  )
}

export default LeftNavLinkContainer
